import theme from '@adsk/alloy-react-theme';

export const ACCOUNT_STATUS_COLOR = {
  active: theme.colors.green500,
  pending: theme.colors.adskBlue500,
  disabled: theme.colors.charcoal200,
  not_invited: theme.colors.yellowOrange500,
};
